import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgInfinitySymbol = function SvgInfinitySymbol(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    viewBox: "0 0 18 10",
    size: size,
    fill: "currentColor"
  }, props), React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1.7,
    d: "M10.377 6.075L7.125 2.824a2.9 2.9 0 100 4.1l4.102-4.1a2.9 2.9 0 110 4.1"
  }));
};

export default SvgInfinitySymbol;